export enum DocumentFreezeCommand {
  Freeze = 'freezeDocument',
  UnFreeze = 'unFreezeDocument',
}

export const stopEvents = (evt) => evt.stop();

export const FreezeDocumentFeature = 'FreezeDocumentFeature';
